import type { QueryDocumentSnapshot } from 'firebase/firestore';
import { getAppBaseUrl } from '@elka/utils';
import type { Ticket } from '@elka/types';

const TASKS_BASE_URL = getAppBaseUrl('tasks', import.meta.env.MODE);

/** A ticket's page in the tasks app. */
export const ticketUrl = (id: string) => `${TASKS_BASE_URL}/tasks/${id}`;

/** The tasks board filtered to my tasks. */
export const tasksBoardUrl = () => `${TASKS_BASE_URL}/?mine=1`;

/**
 * A ticket doc with the tasks app's read defaults, so a doc written before a field
 * existed stays off the error path. 'estimate' shows a just-written timestamp as "now".
 */
export function toTicket(d: QueryDocumentSnapshot): Ticket {
  const data = d.data({ serverTimestamps: 'estimate' });
  return {
    id: d.id,
    ...data,
    priority: data.priority ?? 'normal',
    statusHistory: data.statusHistory ?? [],
    links: data.links ?? [],
    subtasks: data.subtasks ?? [],
  } as Ticket;
}
